import type { VaultDoorState, KeyState } from "./VaultDoor";

export type LivePhase = "idle" | "betting" | "live" | "win" | "bust";

/**
 * Maps live game-store fields to a VaultDoorState for the idle/live stage.
 * Cracked locks become "locked" keys (inserted + turned 90°). The next lock
 * to crack pulses red ("arming") only during the live phase. Door stays
 * closed — the post-cashout SceneWin/SceneBust own the open transitions.
 *
 * Pure function. Pass `t=0` for static renders (marketing tiles); pass
 * `useTime()` for the live stage to drive ambient dial rotation + pulses.
 */
export function liveVaultState(
  t: number,
  phase: LivePhase,
  cracked: number,
  multiplier: number,
): VaultDoorState {
  const keyStates: KeyState[] = ["idle", "idle", "idle", "idle", "idle"];
  const hasKeys: boolean[] = [false, false, false, false, false];
  const keyAngles: number[] = [0, 0, 0, 0, 0];

  for (let i = 0; i < cracked && i < 5; i++) {
    keyStates[i] = "locked";
    hasKeys[i] = true;
    keyAngles[i] = 1;
  }
  if (cracked < 5 && phase === "live") {
    keyStates[cracked] = "arming";
  }

  return {
    t,
    dialAngle: -t * 6 + (multiplier - 1) * 8,
    tension: Math.min(1, cracked / 5 + 0.05 * Math.sin(t * 0.5)),
    danger: cracked >= 4 ? 1 : 0,
    keyStates,
    hasKeys,
    keyAngles,
    keySmokes: [0, 0, 0, 0, 0],
    openMode: undefined,
    openProgress: 0,
  };
}
